<template>
  <div>
    <md-dialog :md-active.sync="userProfileDialog && userProfileDialog.show">
      <md-dialog-title>{{ userProfileDialog.title }}</md-dialog-title>
      <ValidationObserver v-slot="{ invalid }">
        <div v-if="errorMessage != '' && errorMessage != null">
          <p class="errorMsg">{{ errorMessage }}</p>
        </div>
        <div class="md-layout">
          <!-- First Name -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-25"
            label="First Name"
            v-model="user.first_name"
            required
          />

          <!-- Last Name -->
          <validated-text-input
            class="md-layout-item md-small-size-100 md-size-25"
            label="Last Name"
            v-model="user.last_name"
            required
          />

          <!-- Email -->
          <validated-text-input
            label="Email"
            class="md-layout-item md-small-size-100 md-size-50"
            ref="emailRef"
            v-model="user.email"
            melissaCheckType="email"
            @is-melissa-check-passed-changed="updateMelissaCheck('email', $event)"
            required
            immediate
            :disabled ="true"
          />

        </div>

        <div class="md-layout">

          <!-- Mobile no -->
          <validated-text-input
            label="Mobile Number"
            class="md-layout-item md-small-size-100 md-size-25"
            ref="phoneRef"
            v-model="user.phone_number"
            :minLength="10"
            :maxLength="12"
            errormsg="Please enter a valid phone number, format must be a valid Australian number and only include numbers or +"
            melissaCheckType="phone"
            @is-melissa-check-passed-changed="updateMelissaCheck('phone', $event)"
            required
            immediate
          />

          <!-- State -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-25"
            label="State"
            v-model="user.state"
            :options="states"
            alpha-spaces
            force
            required
          />

          <!-- Postcode -->
          <validated-number-input
            class="md-layout-item md-small-size-100 md-size-25"
            label="Postcode"
            v-model="user.postcode"
            integer
            :minLength=4
            :maxLength=10
            :errormsg="user.postcode && user.postcode.length>10 ? 'Postcode accept only 10 digits' : 'Please enter the correct information.'"
            required
          />
        </div>

        <md-dialog-actions>
          <md-button class="md-primary" @click="onEditUserCancel">Cancel</md-button>
          <md-button
            class="md-primary"
            @click="onEditUserSave"
            :disabled="isSaveDisabled(invalid)"
          >Save</md-button>
        </md-dialog-actions>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import validateInputs from '@/components/ValidatedInput';
import ConfirmDialog from '../Dialogs/ConfirmDialog';

export default {
  components: {
    ConfirmDialog,
    ...validateInputs,
  },
  props: {
    userProfileDialog: {
      type: null,
      default: () => {},
    }
  },
  data() {
    return {
      errorMessage: null,
      isMelissaCheckPassed: {
        'email': false,
        'phone': false,
      },
    }
  },
  computed: {
    // standard list of options from store
    ...mapGetters([
      'user',
      'options',
    ]),
  states() {
      return this.options.country_states['Australia'] ?? [];
    }
  },
  methods: {
    async onEditUserSave() {
      await axios.post(
        "/api/v1/user/profile/update", this.user
      ).then(async (res) => {
        this.userProfileDialog.show = false;
        this.errorMessage = "";
        this.$modal.show(ConfirmDialog, {
          title: "Successful",
          message: "Personal Info update successfully.",
          confirmText: "Close",
        });
      }).catch((err) => {
        this.errorMessage = err.response.data;
      });
    },
    onEditUserCancel() {
      this.userProfileDialog.show = false;
    },
    isSaveDisabled(invalid) {
      return !this.isAllMelissaCheckPass() || invalid;
    },
    isAllMelissaCheckPass() {
      return Object.values(this.isMelissaCheckPassed).every(val => val === true);
    },
    updateMelissaCheck(type, value) {
      this.isMelissaCheckPassed[type] = value;
    },
  },
  async beforeCreate() {
    const params = {
      types: [
        'country_states',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
}
</script>
